export default [
  { code: '101', name: '中野店', minutes: 2400 },
  { code: '102', name: '練馬店', minutes: 2100 },
  { code: '103', name: '吉祥寺店', minutes: 2400 },
  { code: '104', name: '南松本店', minutes: 2100 },
  { code: '105', name: '戸越銀座店', minutes: 1800 },
  { code: '106', name: '豪徳寺店', minutes: 1800 },
  { code: '107', name: '熊谷店', minutes: 1800 },
  { code: '108', name: '西葛西店', minutes: 1800 },
  { code: '109', name: '池袋マルイ店', minutes: 1800 },
  { code: '110', name: 'ベイシア前橋モール店', minutes: 1800 },
  { code: '111', name: '大泉学園店', minutes: 2100 },
  { code: '112', name: '幡ヶ谷店', minutes: 2100 },
  { code: '113', name: 'イオンモール神戸南店', minutes: 1800 },
  { code: '114', name: '三宮オーパ2店', minutes: 1800 },
  { code: '115', name: '与野店', minutes: 1800 },
  { code: '116', name: 'イトーヨーカドー三郷店', minutes: 1800 },
  { code: '117', name: '三鷹店', minutes: 1800 },
  { code: '118', name: '中板橋店', minutes: 1800 },
  { code: '119', name: '鶴ヶ峰店', minutes: 1800 },
  { code: '120', name: '西新井店', minutes: 1800 },
  { code: '121', name: '十条店', minutes: 1800 },
  { code: '122', name: '方南町店', minutes: 1800 },
  { code: '123', name: 'MEGAドン・キホーテ蓮田店', minutes: 1800 },
  { code: '124', name: 'MEGAドン・キホーテ四街道店', minutes: 1800 },
  { code: '125', name: 'メイン六甲店', minutes: 1800 },
  { code: '126', name: '阪東橋店', minutes: 1800 },
  { code: '127', name: '雑色店', minutes: 1800 },
  { code: '128', name: 'イオンモール座間店', minutes: 2100 },
  { code: '129', name: 'ビバモール加須店', minutes: 1800 },
  { code: '130', name: 'イオンモール多摩平の森店', minutes: 1800 },
  { code: '131', name: 'イオン浜松西店', minutes: 1800 },
  { code: '132', name: 'イオン豊川店', minutes: 1800 },
  { code: '133', name: '南阿佐谷店', minutes: 1800 },
  { code: '134', name: 'ミウィ橋本店', minutes: 1800 },
  { code: '135', name: 'ビバモール寝屋川店', minutes: 1800 },
  { code: '136', name: 'イオン貝塚店', minutes: 1800 },
  { code: '137', name: 'ビッグホップガーデンモール印西店', minutes: 1800 },
  { code: '138', name: 'イオン入間店', minutes: 1800 },
  { code: '139', name: '新小岩店', minutes: 1800 },
  { code: '140', name: '町屋店', minutes: 1800 },
  { code: '141', name: 'イオンモールいわき小名浜店', minutes: 1800 },
  { code: '142', name: 'イオン瀬戸みずの店', minutes: 1800 },
  { code: '143', name: 'パラディ学園前店', minutes: 1800 },
  { code: '144', name: '京阪百貨店すみのどう店', minutes: 1800 },
  { code: '145', name: '上板橋', minutes: 1800 },
  { code: '146', name: '蒲田', minutes: 1800 },
  { code: '147', name: '中野新橋', minutes: 1800 },
  { code: '148', name: '長崎屋小樽', minutes: 1800 },
  { code: '149', name: 'フローラ88', minutes: 1800 },
]



// WEBPACK FOOTER //
// ./src/mock/reasonableMinutes.js